module.exports = __webpack_public_path__ + "img/signature-sample1.ea2693f5.png";